export enum InvitationStatus {
  Accepted = 'Accepted',
  PendingAcceptance = 'PendingAcceptance',
}
